

import Vue from 'vue'
import FastClick from 'fastclick'
import VueRouter from 'vue-router'
import App from './App'
import Home from './components/HelloFromVux'
import routes from './router/index.js'
import isheader from './views/header/index.js'
import footer from './views/footer/index.js'
import axios from 'axios';
import baseFun from './function.js'
import AlertPlugin from 'vux/src/plugins/alert/index.js'

import host from './host.js';

Vue.use(VueRouter)
Vue.use(isheader)
Vue.use(footer)
Vue.use(AlertPlugin)
Vue.use(baseFun)

const router = new VueRouter({
routes,

})
router.beforeEach((to, from, next) => {
axios.defaults.baseURL = host;
next();
})

FastClick.attach(document.body)

Vue.config.productionTip = false

axios.post(host+'api/5cf613efbc74f').then( (response) => {
if (response.data.code == 1) {
Vue.prototype.xmjsid = response.data.data;
}
})
Vue.prototype.zjPrice = 0;

axios.post(host+'api/5cff7095ac335').then( (response) => {
if (response.data.code == 1) {
Vue.prototype.zjPrice = response.data.data;
}
})

Vue.prototype.zjNum = 0;
axios.post(host+'api/5d09fd0e9782f').then( (response) => {
if (response.data.code == 1) {
Vue.prototype.zjNum = response.data.data;
}
})
Vue.prototype.zjCount = 0;
axios.post(host+'api/5d2ade16637ef').then( (response) => {
if (response.data.code == 1) {
Vue.prototype.zjCount = response.data.data;
}
})

Vue.prototype.host = host;






/* eslint-disable no-new */
new Vue({
router,
render: h => h(App)
}).$mount('#app-box')



// WEBPACK FOOTER //
// ./src/main.js